import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import { LeadsState, SearchAttributes } from '../interfaces/leads';
import LeadsCRUDActions from '../actions/LeadsCRUDActions';

const initialState: LeadsState = {
  busy: false,
  attributes: {},
  contacts: {},
  freezedCretitsSum: 0,
};

const retrievedAll = (
  state: LeadsState,
  action: { entities: SearchAttributes },
) => {
  const { entities } = action;
  return {
    ...state,
    busy: false,
    attributes: entities,
  };
};

export default function leads(state = initialState, action: any) {
  switch (action.type) {
    case LeadsCRUDActions.busyAction:
      return setBusy(state);
    case LeadsCRUDActions.unbusyAction:
      return setUnBusy(state);
    case LeadsCRUDActions.retrievedAllAction:
      return retrievedAll(state, action);
    case LeadsCRUDActions.retrieveLeadsBySearchAttributes: {
      return {
        ...state,
        contacts: action.contacts,
        busy: false,
      };
    }
    case LeadsCRUDActions.resetLeadsAction: {
      return {
        ...state,
        contacts: {},
        busy: false,
      };
    }
    case LeadsCRUDActions.setFreezedCreditsCount: {
      return {
        ...state,
        freezedCretitsSum: action.payload,
        busy: false,
      };
    }
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return { ...state, busy: false };
    default:
      return state;
  }
}
